module.exports = __webpack_public_path__ + "static/team4-2c72310071833233c32407c7ae375916.jpg";